module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_14.be0d1943.jpg";